export const form = {
  uuid: '63fe13fc-c106-4fcc-906e-304a96a37f3d',
  created: '2023-02-14T08:35:06.488822',
  expires_at: '2023-05-15T08:35:06.487888',
  filled: true,
  finished_at: '2023-02-16T14:31:01.134147',
  answers: [
    {
      uuid: 'd309bfe2-c476-4893-9fa0-800e8fcfa28f',
      answer_object: {
        items: [],
        question_name: 'environment_related_activities',
      },
    },
    {
      uuid: '56348c7c-e3d6-4891-acd3-afdb14b7defe',
      answer_object: {
        items: [],
        question_name: 'national_product_offering_activities',
      },
    },
    {
      uuid: 'b2937adb-5411-4070-89d5-ec6a8a5fd480',
      answer_object: {
        items: [],
        question_name: 'international_product_offering_activities',
      },
    },
    {
      uuid: '2d95f8d7-5df7-463a-8a5b-26fd0a66f2fa',
      answer_object: {
        items: [],
        question_name: 'representation_activities',
      },
    },
    {
      uuid: '6be6358c-120a-4d2a-a45c-680b2ae58167',
      answer_object: {
        items: [],
        question_name: 'automation_activities',
      },
    },
    {
      uuid: '8e94683e-5686-4665-a89f-cf956fdd4a93',
      answer_object: {
        items: [],
        question_name: 'kinship_xp',
      },
    },
    {
      uuid: '6aa0ee75-4ee6-43d7-ab8c-720e8d33da4b',
      answer_object: {
        items: [],
        question_name: 'pep_relationship',
      },
    },
    {
      uuid: '048bbdf5-595d-4810-ac23-9082b8debd29',
      answer_object: {
        items: [],
        question_name: 'attorney_activities',
      },
    },
    {
      uuid: 'df4ac1fb-ef63-4825-bdd8-edf3b6f82051',
      answer_object: {
        investments_out_of_xp: {
          aware: false,
          confirmed_being_aware_at: null,
          has_investments_out_of_xp: false,
        },
        question_name: 'third_party_investments',
      },
    },
    {
      uuid: 'b9c2568e-4c0e-46c4-b29a-263ca185d220',
      answer_object: {
        items: [],
        question_name: 'court_lawsuit_cvm_bacen_sfn',
      },
    },
    {
      uuid: '9a000b14-4b03-40ba-90de-280b728a0f94',
      answer_object: {
        items: [],
        question_name: 'environmental_court_lawsuit',
      },
    },
    {
      uuid: 'da5c434c-e34c-4ad6-9548-6320d0d6d1ca',
      answer_object: {
        items: [],
        question_name: 'criminal_court_lawsuit',
      },
    },
    {
      uuid: 'e03a7d3e-4203-41fc-8d51-e6f319a915ac',
      answer_object: {
        items: [],
        question_name: 'negative_media',
      },
    },
    {
      uuid: 'b06d9770-537c-4153-9a52-d8790de95665',
      answer_object: {
        items: [],
        question_name: 'restrictive_list',
      },
    },
    {
      uuid: '0b1ce325-9b54-4bd9-8008-4910490a50b6',
      answer_object: {
        answer: {
          agreed: true,
          terms_accepted_at: '2023-02-15T04:47:50',
        },
        question_name: 'terms_agreement',
      },
    },
    {
      uuid: '64c83efb-c904-45a1-9de4-b1a35fe665b2',
      answer_object: {
        items: [
          {
            address: 'https://validatorpy.readthedocs.io/en/latest/index.html',
            type: 'site',
          },
          {
            address: 'https://validatorpy.readthedocs.io/en/latest/index.html',
            type: 'facebook',
          },
          {
            address: 'https://validatorpy.readthedocs.io/en/latest/index.html',
            type: 'instagram',
          },
        ],
        question_name: 'social_networks',
      },
    },
    {
      uuid: 'ce19a205-4703-4ea0-9e84-294e8c3c726d',
      answer_object: {
        items: [
          {
            developed_activities: 'Negociador de valores mobiliários',
            end_date: '2023-01-29',
            exit_reason: 'Motivos de saúde',
            role: null,
            start_date: '2020-01-06',
          },
        ],
        question_name: 'relation_with_another_companies',
      },
    },
    {
      uuid: 'ca6d7a57-1a75-4bf9-85ac-ac168ddafecd',
      answer_object: {
        items: [
          {
            cnpj: '27231185000100',
            corporate_name: 'Ferreira Gestão Financeira',
            developed_activities: 'Tomava as decisões importantes da empresa',
            role: 'CEO',
            will_keep_role: true,
          },
        ],
        question_name: 'financial_activities',
      },
    },
    {
      uuid: '09afe34e-8e07-4515-a461-c2bde45f9fbe',
      answer_object: {
        items: [
          {
            bond_informed_as_other: 'Trabalhador privado',
            bond_type: 'other',
            currently_at_this_job: true,
            developed_activities:
              'Desenvolvo sistemas web para os clientes da empresa onde trabalho',
            end_of_contract: null,
            end_working_hours: '18:30:00',
            investment_advisory_end_time: '22:00:00',
            investment_advisory_start_time: '19:00:00',
            reports_to: 'Felipe Abou Asli Alves',
            role: 'Analista desenvolvedor I -  Frontend',
            start_working_hours: '09:00:00',
          },
        ],
        question_name: 'external_activities',
      },
    },
  ],
  owner: {
    email: 'lucas.jferreira@dimensa.com.br',
    display_name: 'Lucas Ferreira',
    uuid: '095be615-a8ad-4c33-8e9c-c7612fbf6c9f',
  },
}
